module.exports = {"types":{"0":"research report","1":"meta analysis","2":"study","3":"investigative journalism","4":"article"},"availability":{"0":"full","1":"abstract","2":"paywall"},"tags":{}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/study_metadata_names.json
// module id = 1175
// module chunks = 3